/**
 * View component for /metrics
 *
 * Generic metric list view. Defaults to 'all' with:
 * this.props.dispatch(metricActions.fetchListIfNeeded());
 *
 * NOTE: More list examples are:
 * this.props.dispatch(metricActions.fetchListIfNeeded("all"));
 * this.props.dispatch(metricActions.fetchListIfNeeded()).then((data) => {
 *   console.log("DATA", data);
 * });
 * this.props.dispatch(metricActions.fetchListIfNeeded("_workout"));
 * this.props.dispatch(metricActions.fetchListIfNeeded("_section", "1234"));
 * this.props.dispatch(metricActions.fetchList("_section", "3456", "78910")).then(() => {
 *   this.props.dispatch(metricActions.invalidateList("_section", "3456", "78910"));
 * });
 * this.props.dispatch(metricActions.setFilter({test: 2}));
 * this.props.dispatch(metricActions.setFilter({test: 2}, "_section", "1234"));
 * this.props.dispatch(metricActions.setPagination({test: 1}, "_section", "1234"));
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as metricActions from '../metricActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Pagination from "../../../global/components/helpers/Pagination.js.jsx";
import { SearchInput } from '../../../global/components/forms';

// import metric components
import MetricSelectorSearchItem from '../components/MetricSelectorSearchItem.js.jsx';

// import util components
import routeUtils from "../../../global/utils/routeUtils";

class MetricSelector extends Base {
  constructor(props) {
    super(props);
    this.state = {
      query: {
        page: '1'
        , per: '50'
        , queryText: ''
        , sortBy: 'title'
      }
      , typing: false 
      , typingTimeout: null 
    };
    this._bind(
      '_addMetric'
      , '_handleQuery'
      , '_handleSetPagination'
      , '_handleSort'
      , '_removeMetric'
      , '_refreshList'
      , '_setPerPage'
    );
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(metricActions.fetchListIfNeeded('all'))
  }

  _addMetric(id) {
    console.log("add metric id", id);
    const { change, name, selectedMetrics } = this.props;
    let newSelected = selectedMetrics;
    newSelected.push(id)
    let event = {
      target: {
        name
        , value: newSelected
      }
    }
    change(event);
    this.forceUpdate();
  }

  _removeMetric(id) {
    console.log("remove metric id", id);
    const { change, name, selectedMetrics } = this.props;
    let newSelected = selectedMetrics;
    newSelected.splice(selectedMetrics.indexOf(id),1);
    let event = {
      target: {
        name
        , value: newSelected
      }
    }
    change(event);
    this.forceUpdate();
  }

  _handleSort(sortBy) {
    const { dispatch } = this.props;
    let newQuery = _.cloneDeep(this.state.query);
    newQuery.sortBy = sortBy;
    newQuery.page = "1"; // reset our pagination
    this.setState({query: newQuery});
    dispatch(metricActions.fetchListIfNeeded("search", routeUtils.queryStringFromObject(newQuery)));
  }

  _setPerPage(per) {
    const { dispatch } = this.props;
    let newQuery = _.cloneDeep(this.state.query);
    newQuery.page = '' + 1;
    newQuery.per = '' + per
    this.setState({query: newQuery});
    dispatch(metricActions.fetchListIfNeeded("search", routeUtils.queryStringFromObject(newQuery)));
  }

  _handleSetPagination(newPagination) {
    const { dispatch } = this.props;
    let newQuery = _.cloneDeep(this.state.query);
    newQuery.page = '' + newPagination.page;
    newQuery.per = '' + newPagination.per
    this.setState({query: newQuery});
    dispatch(metricActions.fetchListIfNeeded("search", routeUtils.queryStringFromObject(newQuery)));
  }

  _handleQuery(e) {
    console.log('handlequery');
    const { dispatch } = this.props;
    let newQuery = _.cloneDeep(this.state.query);
    newQuery.queryText = e.target.value.toLowerCase();
    newQuery.page = "1"; // reset our pagination
    if(this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }
    this.setState({
      query: newQuery
      , typing: false 
      , typingTimeout: setTimeout(() => {
        dispatch(metricActions.fetchListIfNeeded("search", routeUtils.queryStringFromObject(newQuery)));
      }, 400)
    });
  }

  _refreshList() {
    this.props.dispatch(metricActions.fetchList("search", routeUtils.queryStringFromObject(this.state.query)));
  }

  render() {
    const { metricStore, selectedMetrics } = this.props;
    console.log('selectedMetrics', selectedMetrics);
    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the metricList meta info here so we can reference 'isFetching'
    const queryString = routeUtils.queryStringFromObject(this.state.query);

    const metrics = metricStore.util.getList("search", queryString);
    const metricList = metricStore.lists.search ? metricStore.lists.search[queryString] : {};
    
    /**
     * NOTE: metricsEmpty is is usefull when the component references more than one
     * resource list.
     */
    const metricsEmpty = !metricList || !metricList.items || metricList.didInvalidate;

    return (
      
      <div className="metric-selector">   
        <div className="-selected-metrics ">
          {selectedMetrics.sort((a, b) => metricStore.byId[a] && metricStore.byId[b] && metricStore.byId[a].order - metricStore.byId[b].order ).map((metricId, i) => 
            <div className="-metric-item" key={metricId + '_' + i}>
              <div className="-order">
                <div className="-order-num">
                  {metricStore.byId[metricId] && metricStore.byId[metricId].order ? metricStore.byId[metricId].order : '-'}
                </div>
              </div>
              <a 
                className="-content"
                href={`${window.authoringUrl}/metrics/${metricId}`}
                target="_blank"
              >
                {metricStore.byId[metricId] && metricStore.byId[metricId].title}
              </a>
              <div className="-action">
                <button type="button" className="yt-btn small link danger" onClick={() => this._removeMetric(metricId)}><i className="ion ion-close-round"/></button>
              </div>
              <hr/>
            </div>
          )}
        </div>   
        <SearchInput
          change={this._handleQuery}
          name="query"
          placeholder="Search for a metric to add..."
          required={false}
          value={this.state.query.queryText}
        />
        {this.state.query.queryText.length > 3 ?
          <div className="yt-row center-vert space-between">
            <button type="button" onClick={this._refreshList} className="yt-btn small link">Refresh results</button>
            <div>
              <span style={{marginRight: "8px"}}><em>Can't find what you're looking for? </em></span>
              <Link className="yt-btn small info" to="/admin/authoring/metrics/new" target="_blank">Make new metric</Link>
            </div>
          </div>  
          :
          null 
        }
        <div className="">
          { metricsEmpty ?
            (metricList && metricList.isFetching ? 
              <div className="u-centerText">
                <div className="loading"></div>
              </div>
              :
              null 
            )
            :
            <div style={{ opacity: metricList.isFetching ? 0.5 : 1 }}>
              <div className="content-container">
                <div className="table-wrapper">
                  <table className="yt-table striped">
                    <caption>
                      { metricList.filter && metricList.filter.queryText && metricList.filter.queryText.length > 0 ?
                        <span>Filtered Metrics &mdash; {metricList.items.length} of {metricList.pagination.total}</span>
                        :
                        <span>All Metrics &mdash; {metricList.pagination ? metricList.pagination.total : 0}</span>
                      }
                      <div className="per-page-select u-pullRight">
                        <label>Show per page: </label>
                        <select
                          name="numPerPage"
                          onChange={(e) => this._setPerPage(e.target.value)}
                          value={this.state.per}
                          >
                          <option value={25}> 25 </option>
                          <option value={50}> 50 </option>
                          <option value={100}> 100 </option>
                        </select>
                      </div>
                    </caption>
                    <thead>
                      <tr>
                        <th></th>
                        <th className="_10 sortable" onClick={()=> this._handleSort(metricList.filter && metricList.filter.sortBy === 'order' ? '-order' : 'order')}>
                          Order
                          {metricList.filter && metricList.filter.sortBy === 'order' ?
                            <i className="ion ion-ios-arrow-down" />
                            : metricList.filter && metricList.filter.sortBy === '-order' ?
                            <i className="ion ion-ios-arrow-up" />
                            : null
                          }
                        </th>
                        <th className="_70 sortable" onClick={()=> this._handleSort(metricList.filter && metricList.filter.sortBy === 'title' ? '-title' : 'title')}>
                          Title
                          {metricList.filter && metricList.filter.sortBy === 'title' ?
                            <i className="ion ion-ios-arrow-down" />
                            : metricList.filter && metricList.filter.sortBy === '-title' ?
                            <i className="ion ion-ios-arrow-up" />
                            : null
                          }
                        </th>
                        <th className="_10 sortable" onClick={()=> this._handleSort(metricList.filter && metricList.filter.sortBy === 'updated' ? '-updated' : 'updated')}>
                          Last Modified
                          {metricList.filter && metricList.filter.sortBy === 'updated' ?
                            <i className="ion ion-ios-arrow-down" />
                            : metricList.filter && metricList.filter.sortBy === '-updated' ?
                            <i className="ion ion-ios-arrow-up" />
                            : null
                          }
                        </th>
                        <th className="_10"></th>
                      </tr>
                    </thead>
                    <tbody className="aut-metrics-table-body">
                      {metrics.map((metric, i) =>
                        <MetricSelectorSearchItem 
                          handleAdd={() => this._addMetric(metric._id)}
                          key={metric._id + '_' + i} 
                          metric={metric} 
                          selected={selectedMetrics.includes(metric._id)}
                        />
                      )}
                    </tbody>
                  </table>
                  { metricList.items.length === 0 ?
                    null
                    :
                    <Pagination
                      classes="u-centerText"
                      totalPages={metricList.pagination ? Math.floor(metricList.pagination.total / metricList.pagination.per) + 1 : 1}
                      pagination={metricList.pagination ? metricList.pagination : {page: 1, per: 50}}
                      setPagination={this._handleSetPagination}
                    />
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

MetricSelector.propTypes = {
  dispatch: PropTypes.func.isRequired
  , change: PropTypes.func.isRequired
  , selectedMetrics: PropTypes.array 
}

MetricSelector.defaultProps = {
  selectedMetrics: []
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    metricStore: store.metric
  }
}

export default withRouter(
    connect(
    mapStoreToProps
  )(MetricSelector)
);



// WEBPACK FOOTER //
// modules/metric/components/MetricSelector.js.jsx